export default __webpack_public_path__ + "static/SequenceMenu_Default-b78320cf45da84cc6a2b4d8ccc4e25f2.png";